import { useLocalStorage } from '@shared/utils/useStorage';
import { createContext, type ReactNode, useContext } from 'react';

interface IAccountProviderContext {
  account: BusinessEntityBase | undefined;
  changeAccount: (account: BusinessEntityBase | undefined) => void;
}

const AccountProviderContext = createContext<IAccountProviderContext>({
  account: undefined,
  changeAccount: () => {},
});

export const useAccountSelector = () => useContext(AccountProviderContext);

interface AccountProviderProps {
  children: ReactNode;
}

const AccountProvider = ({ children }: AccountProviderProps) => {
  const [account, setAccount] = useLocalStorage<BusinessEntityBase | undefined>(
    'user.account',
    undefined
  );

  const changeAccount = (nextAccount: BusinessEntityBase | undefined) => {
    if (nextAccount?.id === account?.id) {
      return;
    }

    setAccount(nextAccount);
    if (!nextAccount) {
      window.location.reload();
    }
  };

  return (
    <AccountProviderContext.Provider
      value={{
        account,
        changeAccount,
      }}
    >
      {children}
    </AccountProviderContext.Provider>
  );
};

export default AccountProvider;
